import { DialogTitle } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { X } from 'phosphor-react';
import type { ComponentProps } from 'react';
import { ButtonCtaGhost } from '../button/button';
import { Header } from '../header/header';


type ModalHeaderProps = Omit<ComponentProps<typeof Header>, 'slotRight'> & {
  onClose: () => void;
};

export const ModalHeader = ({ id, title, className, text, onClose }: ModalHeaderProps) => (
  <>
    <Header
      className={className}
      id={id}
      title={title}
      text={text}
      slotRight={<ButtonCtaGhost icon={X} hideLabel onClick={onClose}>Schließen</ButtonCtaGhost>}
    />
    <VisuallyHidden>
      <DialogTitle>{title}</DialogTitle>
    </VisuallyHidden>
  </>
);
